import { Grid, Typography } from '@mui/material'

import { useTranslation } from 'react-i18next'
import PreviewCard from 'components/PreviewCard'
import { useParams } from 'react-router-dom'
import { getRelationshipTypes } from 'store/lookup'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

export default function ContactsListItem({ item, index, maxSeq }) {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { personId } = useParams()
  const relationshipTypes = useSelector(state => state.lookup.relationshipTypes)

  useEffect(() => {
    relationshipTypes || dispatch(getRelationshipTypes())
  }, [dispatch])

  if (!(item && relationshipTypes)) return null

  return (
    <PreviewCard
      title={index === 0 ? t('First Contact') : t('Second Contact')}
      size="large"
      buttonLabel={item.relationship ? t('More') : t('Add Contact')}
      buttonNavigate={
        item.relationship
          ? `/people/staff/${personId}/contacts/${item.id}`
          : `/people/staff/${personId}/contacts/new?seq=${maxSeq + 1}`
      }
      buttonPermission={'people.contact'}
    >
      <Grid container spacing={2}>
        <Grid item sm={4} xs={4} md={4}>
          <Typography variant="caption">{t('Full Name')}</Typography>
          <Typography variant="body1">
          {item?.contact?.title} {item?.contact?.firstName} {item?.contact?.lastName} &nbsp;
          </Typography>
        </Grid>
        <Grid item sm={4} xs={4} md={4}>
          <Typography variant="caption">{t('Relation')}</Typography>
          <Typography variant="body1">
            {relationshipTypes.find(rt => rt.id === item?.relationship)?.name} &nbsp;
          </Typography>
        </Grid>
        <Grid item sm={4} xs={4} md={4}>
          <Typography variant="caption">{t('Phone Number')}</Typography>
          <Typography variant="body1">
            {item?.contact?.phones?.find(ph => ph.type === 'home')?.number || item?.contact?.phones[0]?.number}
          </Typography>
        </Grid>
      </Grid>
    </PreviewCard>
  )
}
